export default "__VITE_ASSET__D2vZZ40k__"